import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/layout.css';
import { 
  LayoutDashboard, 
  Calendar, 
  BookOpen, 
  GraduationCap,
  Users,
  CreditCard, 
  FileText, 
  Bell, 
  MoreHorizontal,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_NAMESPACE } from '../../utils/constants';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { user } = useAuth0();
  
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isServiceProvider = userRoles.includes('ServiceProvider');
  const isAdmin = userRoles.includes('admin');
  
  const menuItems = [
    { 
      name: 'Dashboard', 
      icon: LayoutDashboard, 
      path: '/dashboard',
      roles: ['ServiceProvider', 'ServiceUser', 'admin']
    },
    { 
      name: 'Manage Templates', 
      icon: Calendar, 
      path: '/template',
      roles: ['ServiceProvider', 'admin']
    },
    { 
      name: 'Bookings', 
      icon: BookOpen, 
      path: '/bookings',
      roles: ['ServiceUser']
    },
    { 
      name: 'Manage Bookings', 
      icon: BookOpen, 
      path: '/manage-bookings',
      roles: ['ServiceProvider']
    },
    { 
      name: 'Manage Students', 
      icon: GraduationCap, 
      path: '/manage-students',
      roles: ['ServiceProvider']
    },
    { 
      name: 'Manage Instructors', 
      icon: Users, 
      path: '/instructors',
      roles: ['admin']  // Admin only
    },
    { 
      name: 'Manage Payments', 
      icon: CreditCard, 
      path: '/payments',
      roles: ['ServiceProvider', 'admin']
    },
    { 
      name: 'Reports', 
      icon: FileText, 
      path: '/report',
      roles: ['ServiceProvider', 'admin']
    },
    { 
      name: 'Notifications', 
      icon: Bell, 
      path: '/notifications',
      roles: ['ServiceProvider', 'ServiceUser', 'admin']
    },
    { 
      name: 'Others', 
      icon: MoreHorizontal, 
      path: '/others',
      roles: ['ServiceProvider', 'admin']
    }
  ];

  // Filter menu items based on user role
  const visibleMenuItems = menuItems.filter(item => {
    //No need to display all menus for users with 'admin' role so commneted out
    // if (isAdmin) return true;  
    return item.roles.some(role => userRoles.includes(role));
  });

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-content">
        {/* Toggle Button */}
        <button 
          className="sidebar-toggle"
          onClick={() => setIsCollapsed(!isCollapsed)}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>

        {/* Menu Items */}
        <nav className="sidebar-nav">
          {visibleMenuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => 
                  `sidebar-item ${isActive ? 'active' : ''}`
                }
                title={isCollapsed ? item.name : ''}
              >
                <Icon size={22} className="sidebar-icon" />
                {!isCollapsed && <span className="sidebar-text">{item.name}</span>}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;